import { render, staticRenderFns } from "./MessageWithIcon.vue?vue&type=template&id=0176ce66&scoped=true"
import script from "./MessageWithIcon.vue?vue&type=script&lang=js"
export * from "./MessageWithIcon.vue?vue&type=script&lang=js"
import style0 from "./MessageWithIcon.vue?vue&type=style&index=0&id=0176ce66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0176ce66",
  null
  
)

export default component.exports